<template>
  <div style="margin-top: 30px">
    <div class="card mx-6">
      <div class="flex justify-content-right">
        <Button label="بحث" icon="pi pi-search" @click="visible = true" />
        <div style="margin: 0 auto"></div>

        <!-- <download-excel v-if="items.length > 0" :data="items" type="xlsx" worksheet="تقرير الطلبة" name="تقرير الطلبة.xlsx" :rtl="true" :fields="json_fields">
          <Button label="تصدير" icon="pi pi-file-excel" severity="help" />
        </download-excel> -->
        <Button label="تصدير" icon="pi pi-file-excel" severity="help" v-if="items.length > 0" @click="exportExcel" />
      </div>

      <div style="height: 30px"></div>

      <!-- <DataTable :value="items" showGridlines tableStyle="min-width: 50rem" :loading="loading">
        <Column field="studentName" header="اسم الطالب"></Column>
        <Column field="collegeNumber" header="الرقم الجامعي"></Column>
        <Column field="acceptedTypeId" header="قناة القبول"></Column>
        <Column field="sectionName" header="القسم"></Column>
      </DataTable> -->
    </div>
  </div>

  <table v-if="items.length > 0" id="customers">
    <thead>
      <tr>
        <td>القسم</td>
        <td>المثبتين لقناة الشهداء الصباحي</td>
        <td>المثبتين لقناة الشهداء المسائي</td>
        <td>المثبتين للقناة العامة الصباحي</td>
        <td>المثبتين للقناة العامة المسائي</td>
        <td>المثبتين لقناة المنحة المجانية الصباحي</td>
        <td>المثبتين لقناة المنحة المجانية المسائي</td>
        <td>المثبتين لقناة الرعاية الصباحي</td>
        <td>المثبتين لقناة الرعاية المسائي</td>
        <td>المجموع الكلي</td>
      </tr>
    </thead>
    <tr v-for="(section, index) in $store.state.sectionsData" :key="index">
      <td @click="printReport(section)" style="cursor: pointer">{{ section.sectionName }}</td>
      <td>{{ getByAcceptedType(5, section.idSection, "1") }}</td>
      <td>{{ getByAcceptedType(5, section.idSection, "2") }}</td>
      <td>{{ getByAcceptedType(4, section.idSection, "1") }}</td>
      <td>{{ getByAcceptedType(4, section.idSection, "2") }}</td>
      <td>{{ getByAcceptedType(7, section.idSection, "1") }}</td>
      <td>{{ getByAcceptedType(7, section.idSection, "2") }}</td>
      <td>{{ getByAcceptedType(66, section.idSection, "1") }}</td>
      <td>{{ getByAcceptedType(66, section.idSection, "2") }}</td>
      <td>{{ getMorning(section.idSection, "1") + getMorning(section.idSection, "2") }}</td>
    </tr>
  </table>
  <p>مجموع الطلبة : {{ totalStudy("1") + totalStudy("2") }}</p>

  <Dialog v-model:visible="visible" header="بحث في الطلبة" :style="{ width: '55rem' }" position="top" :modal="true" :draggable="false" style="direction: rtl">
    <div class="flex-auto">
      <label for="section" class="font-bold block mb-2 text-direction-right">القسم المختار</label>
      <Select id="section" v-model="generatedType" checkmark showClear :options="generatedTypes" optionLabel="name" optionValue="id" placeholder="نوع التقرير" class="w-full md:w-56 mb-5" />
    </div>

    <div class="flex justify-end gap-2">
      <Button type="button" label="بحث" @click="searchStudent" :loading="loading"></Button>
    </div>
  </Dialog>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
const Excel = require("exceljs");

export default {
  data: () => ({
    visible: false,
    sectionName: null,
    acceptedTypeId: null,
    loading: false,
    items: [],
    generatedType: 1,
    generatedTypes: [
      { id: 1, name: "بدون مدفوعات" },
      { id: 2, name: " مدفوعات" },
    ],
    dates: null,
    json_fields: {
      "اسم الطالب": "studentName",
      "الرقم الجامعي": "collegeNumber",
      "الرقم الامتحاني": "examNumber",
      المواليد: "dob",
      "قناة القبول": "acceptedTypeId",
      "جنس الطالب": "gender",
      القسم: "sectionName",
      "اسم المدرسة": "schoolName",
      الملاحظات: "notes",
      التربية: "education",
      "رقم الهاتف": "studentPhone",
      "رقم الهاتف الثاني": "relativePhoneNumber",
    },
  }),
  created() {
    let self = this;
  },
  methods: {
    convertToMySQLDate(inputDate) {
      // Split the input date by '/' to extract day, month, and year
      const [month, day, year] = inputDate.split("/").map(Number);

      // Ensure day and month are two digits by adding a leading zero if necessary
      const formattedDay = day < 10 ? `0${day}` : day;
      const formattedMonth = month < 10 ? `0${month}` : month;

      // Combine the parts into the MySQL date format
      const mysqlDate = `${year}-${formattedMonth}-${formattedDay}`;

      return mysqlDate;
    },
    exportExcel() {
      let self = this;
      const workbook = new Excel.Workbook();
      const worksheet = workbook.addWorksheet("student paid");
      worksheet.views = [{ rightToLeft: true }];

      worksheet.columns = [
        { header: "اسم الطالب", key: "studentName", width: 50 },
        { header: "الرقم الجامعي", key: "collegeNumber", width: 50 },
        { header: "القسم", key: "sectionName", width: 30 },
        { header: "نوع الدراسة", key: "studyType", width: 20 },
      ];

      let sortedData = self.items.sort((a, b) => a.sectionId - b.sectionId);

      sortedData.forEach((student) => {
        worksheet.addRow({
          studentName: student.studentName,
          collegeNumber: student.collegeNumber,
          sectionName: self.$store.state.sectionsData.find((section) => section.idSection == student.sectionId).sectionName || "لايوجد",
          studyType: student.studyType == 1 ? "صباحي" : "مسائي",
        });
      });

      worksheet.eachRow(function (row, rowNumber) {
        row.eachCell((cell) => {
          cell.alignment = { vertical: "middle", horizontal: "center" };
        });
      });

      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.fill = {
          type: "pattern",
          pattern: "darkTrellis",
          fgColor: { argb: "FFFFFF00" },
          bgColor: { argb: "FF0000FF" },
        };
      });

      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("style", "display: none");
        a.href = url;
        a.download = `expensesReport.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      });
    },
    totalStudy(type) {
      let self = this;
      let data = self.items.filter((stu) => stu.studyType == type);
      return data.length;
    },
    getByAcceptedType(type, sectionId, studyType) {
      let self = this;
      let data = self.items.filter((stu) => stu.acceptedTypeId == type && stu.sectionId == sectionId && stu.studyType == studyType);
      console.log(data);
      return data.length;
    },
    getForReport(sectionId) {
      let self = this;
      let data = self.items.filter((stu) => stu.sectionId == sectionId);
      console.log(data);
      return data;
    },
    getMorning(sectionId, type) {
      let self = this;
      let data = self.items.filter((stu) => stu.sectionId == sectionId && stu.studyType == type);
      console.log(data);
      return data.length;
    },
    searchStudent() {
      let self = this;
      self.loading = true;
      let loader = this.$loading.show({
        // Optional parameters
        canCancel: false,
        onCancel: this.onCancel,
      });

      if (self.generatedType == 1) {
        let query = "1=1";
        if (self.sectionName) {
          query += `&sectionName=${self.sectionName}`;
        }
        if (self.acceptedTypeId) {
          query += `&acceptedTypeId=${self.acceptedTypeId}`;
        }

        if (self.dates != null) {
          let firstDate = new Date(self.dates[0]).toLocaleDateString("en-US", { year: "numeric", month: "numeric", day: "numeric" });
          let secondDate = new Date(self.dates[1]).toLocaleDateString("en-US", { year: "numeric", month: "numeric", day: "numeric" });
          let allowDates = [self.convertToMySQLDate(firstDate), self.convertToMySQLDate(secondDate)];
          query += `&dates=${JSON.stringify(allowDates)}`;
        }

        self.$http
          .get(`${self.$store.state.apiUrl}/getStudents?studentStatusId=4`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          })
          .then((res) => {
            console.log(res.data);
            loader.hide();
            self.items = res.data;
          })
          .catch((err) => {
            console.log(err);
            loader.hide();
          });
        self.visible = false;
      } else {
        self.$http
          .get(`${self.$store.state.apiUrl}/studentPayOne`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          })
          .then((res) => {
            console.log(res.data);
            loader.hide();
            self.items = res.data;
          })
          .catch((err) => {
            console.log(err);
            loader.hide();
          });
        self.visible = false;
      }
    },
    printReport(section) {
      let self = this;
      console.log("asd");
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
      });

      let arabicLang = new URL(`./../assets/IBMPlexSansArabic-Medium.ttf`, import.meta.url).href;
      doc.addFileToVFS("IBMPlexSansArabic-Medium.ttf", arabicLang);
      doc.addFont(arabicLang, "IBMPlexSansArabic-Medium", "normal");
      doc.setFont("IBMPlexSansArabic-Medium");

      let studentData = this.getForReport(section.idSection);
      const tableData = [["الدراسة", "قناة القبول", "القسم", "الرقم الجامعي", "اسم الطالب", "ت"]];
      console.log(studentData[0]);
      let rows = studentData.map((rep, index) => {
        return [rep.studyType == 1 ? "صباحي" : "مسائي", rep.acceptedName, section.sectionName, rep.collegeNumber, rep.studentName, index + 1];
      });
      doc.autoTable({
        head: [tableData[0]],
        body: rows,
        styles: {
          font: "IBMPlexSansArabic-Medium",
          halign: "right",
          fontSize: 7,
        },
        headStyles: { fillColor: "#354f52" }, // Optional styling for header
        margin: { top: 0, left: 0, right: 0, bottom: 0 },
      });

      // const pdfBlob = doc.output("blob");
      // const pdfUrl = URL.createObjectURL(pdfBlob);
      // const pdfWindow = window.open(pdfUrl);
      let today = new Date();
      doc.save(`${section.sectionName}-${today.toLocaleDateString("en-GB")}.pdf`);
    },
  },
};
</script>

<style lang="scss" scoped>
#customers {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  margin: 0 auto;
  width: 95%;
}

#customers td,
#customers th {
  border: 1px solid #212529;
  padding: 8px;
}

#customers tr:nth-child(even) {
  background-color: #5fa8d3;
}

#customers tr:hover {
  background-color: #adb5bd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #212529;
  color: white;
}
</style>
